import { render, staticRenderFns } from "./themeDetails.vue?vue&type=template&id=af1c3d94&scoped=true&"
import script from "./themeDetails.vue?vue&type=script&lang=js&"
export * from "./themeDetails.vue?vue&type=script&lang=js&"
import style0 from "./themeDetails.vue?vue&type=style&index=0&id=af1c3d94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1c3d94",
  null
  
)

export default component.exports